interface IValidationEntryProps {
  description: string;
  isValid: boolean;
}

export const ValidationEntry = (props: IValidationEntryProps) => {
  const { description, isValid } = props;

  return (
    <li
      className={`validation-entry--container ${isValid ? "valid" : "invalid"}`}
    >
      <span className={`validation-indicator`} />
      <span className="validation-description switchapp-small font-ctm--semibold">
        {description}
      </span>
    </li>
  );
};
